import { createFileRoute, redirect } from "@tanstack/react-router";
import { CourseStudy } from "../../pages/Courses/CourseStudy";
import { LoaderSpinner } from "@/components/ui/LoaderSpinner";
import { getAccessToken } from "@/utils/storage/authStorage";

export const Route = createFileRoute("/(app)/_app/course/$courseKey")({
	component: CourseStudy,
	beforeLoad: async ({ context }) => {
		// Get token from context or Storage
		const token =
			(context as { token: string | null }).token || (await getAccessToken());

		if (!token) {
			redirect({
				to: "/login",
			});
		}

		return { token };
	},
	pendingComponent: () => {
		return (
			<div className="flex justify-center items-center h-screen">
				<LoaderSpinner className="p-3" size={6} />
			</div>
		);
	},
});
